import { EXTERNAL_ID_SESSION_STORAGE_KEY } from '@cof/refi-web-sdk/dist/utils/stratum.js';
import { REFI_MFE_UUID } from '@cof/refi-web-sdk';
import { DebugService } from '../../../shared/services/debug.service.js';
import { REFI_CREDITPULL_CONST } from '../../../shared/constants/app.constants.js';

class _SessionService {
  constructor() {
    this.debug = new DebugService('SessionService');
    this.refreshSession();
  }

  get session() {
    this.debug.log('getting session', this._session);
    return this._session;
  }

  get mockConsentSession() {
    this._session = {
      eAppId: '123645364',
      borrowerInfo: {
        firstName: 'Andy',
        lastName: 'Smith',
      },
      currentApp: {
        appId: 234,
        statFlag: 11,
        appStatusId: 405,
        validityEndDate: '2024-10-20T21:12:07.397Z',
      },
    };
    return this._session;
  }

  get mockReviewingSession() {
    this._session = {
      eAppId: '123645364',
      borrowerInfo: {
        firstName: 'Andy',
        lastName: 'Smith',
      },
      currentApp: {
        appId: 234,
        statFlag: 61,
        appStatusId: 403,
        validityEndDate: '2024-10-20T21:12:07.397Z',
      },
    };
    return this._session;
  }

  get mockHardpullCombinedContractSession() {
    this._session = {
      eAppId: '123645364',
      borrowerInfo: {
        firstName: 'Billy',
        lastName: 'Bob',
      },
      currentApp: {
        appId: 234,
        statFlag: 11,
        appStatusId: 405,
        validityEndDate: '2024-10-20T21:12:07.397Z',
      },
    };
    return this._session;
  }

  get mockHardpullDeclineSession() {
    this._session = {
      eAppId: '123645364',
      borrowerInfo: {
        firstName: 'Andy',
        lastName: 'Smith',
      },
      currentApp: {
        appId: 234,
        statFlag: 61,
        appStatusId: 402,
        validityEndDate: '2024-10-20T21:12:07.397Z',
      },
    };
    return this._session;
  }

  set session({ appStatusId, statFlag }) {
    if (!this._session?.currentApp) {
      this._session = JSON.parse(
        sessionStorage.getItem(this.sessionStorageKey)
      );
    }
    Object.assign(this._session.currentApp, { appStatusId, statFlag });
    sessionStorage.setItem(
      this.sessionStorageKey,
      JSON.stringify(this._session)
    );
  }

  getKey(sessionKey) {
    return sessionStorage.getItem(sessionKey);
  }

  get pfci() {
    this.debug.log('getting pfci', this._pfci);
    return this._pfci;
  }

  set pfci(value) {
    this._pfci = value;
    sessionStorage.setItem(this.pfciStorageKey, value);
  }

  getAppId() {
    const session = JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
    try {
      return session ? session.currentApp.appId : null;
    } catch {
      return null;
    }
  }

  getExternalId() {
    return sessionStorage.getItem(EXTERNAL_ID_SESSION_STORAGE_KEY);
  }

  setApp(eAppId, app) {
    this._session = { eAppId, currentApp: app };
    sessionStorage.setItem(
      this.sessionStorageKey,
      JSON.stringify(this._session)
    );
  }

  setReferrerId() {
    this._session.referrerId = REFI_MFE_UUID.REFI_APPLY;
    sessionStorage.setItem(
      this.sessionStorageKey,
      JSON.stringify(this._session)
    );
  }

  refreshSession() {
    this.sessionStorageKey = REFI_CREDITPULL_CONST.REFI_SESSION_KEY;
    this._session = JSON.parse(sessionStorage.getItem(this.sessionStorageKey));

    this._pfci =
      sessionStorage.getItem(REFI_CREDITPULL_CONST.REFI_PI_KEY) === '1';
  }

  removeSession() {
    this.debug.log('removeSession');
    sessionStorage.removeItem(this.sessionStorageKey);
  }

  getCachedOffer() {
    const promoStageKey = REFI_CREDITPULL_CONST.REFI_PROMO_STORAGE_KEY;
    const offerString = localStorage.getItem(promoStageKey);
    if (!offerString) {
      return null;
    }
    let offer = JSON.parse(offerString);
    if (!offer.expirationDate) {
      return null;
    }
    if (!this.isOfferStillValid(new Date(offer.expirationDate))) {
      offer = null;
      this.removeCachedOffer();
      this.debug.log('offer expired');
    }
    return offer;
  }

  isOfferStillValid(expirationDate) {
    const currentdate = new Date();
    if (!expirationDate || expirationDate < currentdate) {
      return false;
    }
    return true;
  }

  removeCachedOffer() {
    this.debug.log('removing access code offer');
    localStorage.removeItem(REFI_CREDITPULL_CONST.REFI_PROMO_STORAGE_KEY);
    sessionStorage.removeItem(REFI_CREDITPULL_CONST.REFI_PROMO_STORAGE_KEY);
  }
}

export const SessionService = new _SessionService();
